<template>
  <!-- HTML 정의하는 부분 -->
  <!-- 1차 퍼블리셔가 작업 영역 -->
  <!-- 2차 개발자가 Template 화 작업 진행-->
  <v-container fluid>
    <v-row justify="center">
      <v-col md="5">
        <v-tabs centered v-model="tab">
          <v-tab>
            아이디 찾기
          </v-tab>
          <v-tab>
            비밀번호 찾기
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card>
              <v-card-title>
                아이디 찾기
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text v-if="showFindIdResult">
                <v-row>
                  <v-col cols="12">
                    {{findIdList.length > 0 ? "고객님의 정보와 일치하는 아이디 목록입니다." : "일치하는 아이디 정보가 없습니다."}}
                  </v-col>
                  <v-col cols="12" v-if="findIdList.length > 0">
                    <v-radio-group v-model="selectUserId">
                      <v-radio
                        v-for="item in findIdList"
                        :key="item.USER_ID"
                        :label="item.USER_ID"
                        :value="item.USER_ID"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="6">
                    <v-btn outlined class="default-btn" link block to="/login">로그인하기</v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn outlined class="default-btn" block @click="tab = 1">비밀번호찾기</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-else>
                <v-row>
                  <v-col cols="12">
                    <v-text-field :rules="[rules.required]" label="이름" v-model="name" dense outlined hide-details="auto" ></v-text-field>
                  </v-col>
                  <phone-certificate :create-type="true" :toggle-init="toggleInit" :phone-number="phone" @isCertificateOk="updatePhoneNumber"></phone-certificate>
                  <v-col cols="6">
                    <v-btn outlined class="default-btn" block @click="back">취소</v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn outlined class="default-btn" :disabled="!isCertificateOk" block @click="findId">찾기</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <v-card-title>
                비밀번호 찾기
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text v-if="showChangePasswordResult">
                <v-row>
                  <v-form ref="pwForm" lazy-validation>
                  <v-col cols="12">
                    <v-text-field :rules="[rules.required, rules.isPw]" type="password" label="비밀번호" v-model="password1" dense outlined hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field :rules="[rules.required, rules.isPw, rules.equals(password2,password1,'비밀번호가 일치하지 않습니다.')]" type="password" label="비밀번호 재확인" v-model="password2" dense outlined hide-details="auto"></v-text-field>
                  </v-col>
                  </v-form>
                  <v-col cols="6">
                    <v-btn outlined class="default-btn" link block to="/" @click="back">취소</v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn outlined class="default-btn" block @click = "changePassword">변경</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-else>
                <v-row>
                  <v-col cols="12">
                    <v-text-field :rules="[rules.required]" label="이름" v-model="name" dense outlined hide-details="auto" ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field :rules="[rules.required]" label="아이디" v-model="id" dense outlined hide-details="auto" ></v-text-field>
                  </v-col>
                  <phone-certificate :create-type="true" :toggle-init="toggleInit" :phone-number="phone" :user-id="id" @isCertificateOk="updatePhoneNumber"></phone-certificate>
                  <v-col cols="6">
                    <v-btn outlined class="default-btn" link block to="/" @click="back">취소</v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn outlined class="default-btn" :disabled="!isCertificateOk" block @click="findPassword">찾기</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
import irules from '@/utils/rules'
import PhoneCertificate from '@/layout/components/PhoneCertificate'
import { changePassword, findId } from '@/api/common/user'
import Message from '@/utils/message'
import store from '@/store'

export default {
  name: 'FindIdPw',
  components: {
    PhoneCertificate
  },
  data() {
    return {
      toggleInit: false,
      rules: irules,
      tab: 0,
      name: '',
      id: '',
      phone: '',
      password1: '',
      password2: '',
      isCertificateOk: false,
      findIdList: [],
      selectUserId: '',
      showFindIdResult: false,
      showChangePasswordResult: false
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    if (this.$route.query.type === 'id') {
      this.tab = 0
    } else {
      this.tab = 1
    }
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
  },
  watch: {
    tab: function() {
      if (this.selectUserId !== '') {
        this.id = this.selectUserId
        this.selectUserId = ''
      } else {
        this.init()
        this.toggleInit = !this.toggleInit
      }
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    updatePhoneNumber(value) {
      this.isCertificateOk = true
      this.phone = value
    },
    init() {
      this.name = ''
      this.phone = ''
      this.isCertificateOk = false
      this.findIdList = []
      this.showFindIdResult = false
      this.showChangePasswordResult = false
    },
    back() {
      this.$router.go(-1)
    },
    findId() {
      if (!this.isCertificateOk) {
        Message.err('휴대폰 인증이 처리되지 않았습니다.')
        return
      }
      let data = {
        userId: '',
        name: this.name,
        phone: this.phone
      }
      findId(data).then(res => {
        this.findIdList = res
        this.showFindIdResult = true
      })
    },
    findPassword() {
      if (!this.isCertificateOk) {
        Message.err('휴대폰 인증이 처리되지 않았습니다.')
        return
      }

      let data = {
        userId: this.id,
        name: this.name,
        phone: this.phone,
        password: this.password1
      }
      findId(data).then(res => {
        if (res.length === 0) {
          Message.err('일치하는 정보가 없습니다.')
        } else {
          this.showChangePasswordResult = true
        }
      })
    },
    changePassword() {
      if (!this.$refs.pwForm.validate()) return
      let data = {
        userId: this.id,
        name: this.name,
        phone: this.phone,
        password: this.password1
      }
      changePassword(data).then(res => {
        if (res) {
          store.dispatch('ClearSession')
          Message.success('변경이 완료되었습니다. 로그인페이지로 이동합니다.')
          setTimeout(() => {
            this.back()
          }, 1000)
        } else {
          Message.err('변경이 실패했습니다. 관리자에 문의하세요.')
        }
      }).catch(err => {
        Message.err(err?.response?.data?.result?.desc || '변경이 실패했습니다. 관리자에 문의하세요.')
      })
    }
  }
}
</script>

<style scoped>

</style>
